import { Link } from '../i18n';

export default function LegalRelated() {
  return (
    <div className="related-docs">
      <h3>Documentos legales relacionados</h3>
      <div className="related-docs-row">
        <Link to="/aviso-legal" className="doc-btn">Aviso Legal</Link>
        <Link to="/politica-privacidad" className="doc-btn">Privacidad</Link>
        <Link to="/cookies" className="doc-btn">Cookies</Link>
        <Link to="/devolucion" className="doc-btn">Desistimiento y devoluciones</Link>
        <Link to="/terminos" className="doc-btn">Términos y condiciones</Link>
      </div>
    </div>
  );
}
